import styled from 'styled-components'
import { ClickableContainer } from './ClickableContainer'

export const DeletedOverlay = styled(ClickableContainer)`
	position: relative;
	&:after {
		content: '';
		position: absolute;
		z-index: 10;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		background: rgba(255, 255, 255, 0.4);
		backdrop-filter: blur(1px) grayscale(50%);
	}
`
